import { render, staticRenderFns } from "./MassagesPrices.vue?vue&type=template&id=743a4271&"
import script from "./MassagesPrices.vue?vue&type=script&lang=js&"
export * from "./MassagesPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports